// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-target[data-v-23b2484c] {\n  background-color: #fff3cd;\n  font-weight: bold;\n  border: 1px solid #ffeeba;\n  margin: 0;\n  padding-top: 5px;\n}\n.event-target .col-5[data-v-23b2484c] {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
